"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));

var Edit_1 = __importDefault(require("@material-ui/icons/Edit"));

var Cancel_1 = __importDefault(require("@material-ui/icons/Cancel"));

var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));

var Hoc = __importStar(require("../hoc"));

var ui_1 = require("../ui");

var useStyles = makeStyles_1.default(function (theme) {
  return {
    icon: {
      position: 'absolute',
      right: theme.spacing(0.5),
      top: theme.spacing(0.5)
    }
  };
});

var ToggleLayout = function ToggleLayout(props) {
  var classes = useStyles();
  var children = props.children,
      onClick = props.onClick,
      toggle = props.toggle;
  return react_1.default.createElement(ui_1.Frame, null, react_1.default.createElement(IconButton_1.default, {
    className: classes.icon,
    color: "inherit",
    onClick: onClick
  }, toggle ? react_1.default.createElement(Cancel_1.default, null) : react_1.default.createElement(Edit_1.default, null)), children);
};

var Toggle = Hoc.Toggle()(ToggleLayout);
exports.default = Toggle;